import { testimonials } from "@/mocks/comics";

export default function Testimonials() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="flex items-center justify-center gap-2">
            <span className="w-2 h-2 rounded-full bg-primary-500" />
            <span className="text-xs font-semibold text-primary-600 whitespace-nowrap">
              读者口碑
            </span>
          </div>
          <h2 className="mt-3 text-2xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight">
            他们都在韩漫屋看漫画
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            来自真实读者的评价，一起加入我们的漫画社区
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item, idx) => (
            <div
              key={item.id}
              className={`p-5 md:p-6 rounded-lg bg-background-50 border border-background-200 ${
                idx === testimonials.length - 1 ? "opacity-70" : ""
              }`}
            >
              <div className="flex items-center gap-0.5">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < item.rating
                        ? "ri-star-fill text-secondary-500"
                        : "ri-star-line text-foreground-300"
                    }`}
                  />
                ))}
              </div>
              <h3 className="mt-3 text-sm font-bold font-heading text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                {item.content}
              </p>
              <div className="mt-4 flex items-center gap-3">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-9 h-9 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-xs font-semibold text-foreground-950">
                    {item.name}
                  </p>
                  <p className="text-[11px] text-foreground-400">{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}